import { useAnalyticsContext, UseTrackEvent } from '@faro/app-context';
import { useParams } from 'react-router';
import { StudySpaceAnalyticEventKey } from './AnalyticEventKey';
import { StudySpaceAnalyticEventPayload } from './AnalyticEventPayload';
import { StudySpaceBaseEvent } from './Event';

const useStudySpaceBaseEventData = (): StudySpaceBaseEvent => {
    const { spaceId } = useParams();
    return { product: 'Study Space', spaceId };
};

export type UseTrackStudySpaceEvent = UseTrackEvent<StudySpaceBaseEvent, StudySpaceAnalyticEventPayload>;

const useStudySpaceAnalytics = (): UseTrackStudySpaceEvent => {
    const { createTracker } = useAnalyticsContext();
    const studySpaceBaseEventData = useStudySpaceBaseEventData();
    const trackEvent = createTracker<StudySpaceAnalyticEventPayload>();

    const trackStudySpaceEvent = (
        eventName: StudySpaceAnalyticEventKey,
        payload?: Omit<StudySpaceAnalyticEventPayload[StudySpaceAnalyticEventKey], keyof StudySpaceBaseEvent> &
            Partial<StudySpaceBaseEvent>
    ): void => {
        trackEvent(eventName, {
            ...studySpaceBaseEventData,
            ...(payload ?? {}),
        });
    };

    return {
        trackEvent: trackStudySpaceEvent,
    };
};

export { useStudySpaceAnalytics };
